const VerifyResult = {
  OK: 'Ok',
  FAILED: 'Failed',
  NO_STATUS: 'No status'
};
const VerifyResultColorTag = {
  Ok: '#7ECF42',
  Failed: '#E74C3C',
  NoStatus: '#A9A9A9'
};
export { VerifyResult, VerifyResultColorTag };
